module.exports = __webpack_public_path__ + "static/join-us-1cfa99f3a1cd34d097d2cfc8f9f1dab6.jpg";